import { Component, ViewChild, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { AnalisisDeBrechasService } from '../../../services/analisis-de-brechas.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { TablaDeEvaluacion } from 'app/main/models/tabla-de-evaluacion.model';
import { Sentencia } from 'app/main/models/sentencia.model';
import { ReactiveFormsModule,FormControl ,Validators} from '@angular/forms';

@Component({
    selector   : 'sentencia-resultado-table',
    templateUrl: './sentencia-resultado-table.component.html',
    styleUrls  : ['./sentencia-resultado-table.component.scss']
})
export class SentenciaResultadoTableComponent
{
  @Input() esMultiple: boolean;
  @Input() tablaDeAnalisisDeBrechas:TablaDeEvaluacion; 
  @Input() analisisDeBrechasEstado:string;
  @Input() isResponsable: boolean;
  @Input() sentencia: Sentencia;
  

  @Output("loadData") loadData: EventEmitter<any> = new EventEmitter();

    displayedColumns: string[] = ['nombre','respuesta'];
    is_eval_owner = false;
    is_admin = false;
    rateControl:FormControl;

    sentenciaStr : string;

    constructor(public translate: TranslateService,
                private _snackBar: MatSnackBar,
                private service: AnalisisDeBrechasService
                ) {}

    
    ngOnInit() {

      this.sentenciaStr = JSON.stringify(this.sentencia);
      this.rateControl = new FormControl("", [])

      console.log(this.tablaDeAnalisisDeBrechas);
      console.log(this.esMultiple);
      console.log(this.isResponsable);

      this.sentencia.valores.sort((n1,n2) => {
        if (n1.opcion.nombre > n2.opcion.nombre) {
            return 1;
        }
        if (n1.opcion.nombre < n2.opcion.nombre) {
            return -1;
        }
        return 0;
    });

    if(this.esMultiple){
      this.tablaDeAnalisisDeBrechas.opciones.sort((n1,n2) => {
          if (n1.nombre > n2.nombre) {
              return 1;
          }
          if (n1.nombre < n2.nombre) {
              return -1;
          }
          return 0;
      });
    }else{
      this.tablaDeAnalisisDeBrechas.opciones.sort((n1,n2) => {
        if (n1.valor > n2.valor) {
            return 1;
        }
        if (n1.valor < n2.valor) {
            return -1;
        }
        return 0;
    });
    }



      var algo = this.tablaDeAnalisisDeBrechas.opciones;
    }

    selectRespuesta(sentencia,respuesta):void{
      this.service.addRespuesta(sentencia.id,respuesta.value).pipe().subscribe(req => {
        sentencia.valor = respuesta.value;
        this.loadData.emit({sentencia: sentencia});
      },
      err => {
        this.openSnackBar("No se pudo registrar la respuesta, ocurrió un error.","Cerrar");
      });
    }

    saveValue(sentencia,respuesta):void{
      var error = false;
      if(respuesta.valor!=0 && respuesta.valor <respuesta.opcion.valorMinimo){
        respuesta.valor = respuesta.opcion.valorMinimo;
        this.openSnackBar("No se pudo ingresar un valor menor a "+respuesta.opcion.valorMinimo,"Cerrar");
      }
      if(respuesta.valor!=0 && respuesta.valor >respuesta.opcion.valorMaximo){
        respuesta.valor = respuesta.opcion.valorMaximo;
        this.openSnackBar("No se pudo ingresar un valor superior a "+respuesta.opcion.valorMaximo,"Cerrar");
      }
      
        this.service.addRespuestaObjetivo(sentencia.id,respuesta).pipe().subscribe(req => {

          this.loadData.emit();
        },
        err => {
          this.openSnackBar("No se pudo registrar la respuesta, ocurrió un error.","Cerrar");
        });
    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 3000,
      });
    }

    compareObjects(o1: any, o2: any): boolean {
      var equals = false;
      if(o1!=null && o2!=null)
        equals = o1.nombre === o2.nombre && o1.id === o2.id
      return equals;
    }

    sortComparator(a:any, b:any){
      if ( a.nombre < b.nombre ){
        return 1;
      }
      if ( a.nombre > b.nombre ){
        return -1;
      }
      return 0;
    }



}
